import { ReactNode } from 'react';
import { CDN, CompanyLogoFile, normalizeLogoCid } from '@src/utils/company-logo-constants';
import { Background, BackgroundType } from '../../designConstants';
import { Img } from '../../Img';

const BPM_LOGO_SRC = `https://cdn.blisspointmedia.com/logos/logo_dark.svg`;

const SQUARE_LOGO_FILENAME: Record<BackgroundType, string> = {
  [Background.LIGHT]: CompanyLogoFile.SQUARE_LOGO,
  [Background.DARK]: CompanyLogoFile.SQUARE_LOGO_DARK
};

const getCompanyLogoSrc = (cid: string, background: BackgroundType): string =>
  `${CDN}/companies/${normalizeLogoCid(cid)}/${SQUARE_LOGO_FILENAME[background]}`;

interface ClientLogoProps {
  cid: string;
  unloader?: ReactNode;
  // The background the logo sits on, which picks the matching square logo variant.
  background: BackgroundType;
}

export const ClientLogo = ({ cid, unloader, background }: ClientLogoProps): ReactNode => (
  <Img
    className='logo'
    alt={cid}
    src={cid ? getCompanyLogoSrc(cid, background) : BPM_LOGO_SRC}
    unloader={unloader}
  />
);
